/** Join truthy class names. */
export const cx = (...parts) => parts.filter(Boolean).join(' ');
